import * as tslib_1 from "tslib";
import { IgCollection } from "igniteui-react-core";
import { markType } from "igniteui-react-core";
import { SyncableObservableCollection$2 } from "igniteui-react-core";
import { CellRange as CellRange_internal } from './CellRange';
import { IgrCellRange as IgrCellRange } from './igr-cell-range';
var IgrGridSelectedCellRangesCollection = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(IgrGridSelectedCellRangesCollection, _super);
    function IgrGridSelectedCellRangesCollection(list) {
        var _this = _super.call(this) || this;
        if (!IgrCellRange.$type) {
            IgrCellRange.$type = markType(IgrCellRange, "IgrCellRange");
        }
        if (list) {
            for (var i = 0; i < list.length; i++) {
                _this.add(list[i]);
            }
        }
        return _this;
    }
    IgrGridSelectedCellRangesCollection.prototype._createInnerColl = function () {
        if (!IgrCellRange.$type) {
            IgrCellRange.$type = markType(IgrCellRange, "IgrCellRange");
        }
        var coll = new SyncableObservableCollection$2(IgrCellRange.$type, CellRange_internal.$type, 0);
        coll.compare = function (ext, int) {
            var comp = ext;
            if (comp._implementation) {
                comp = comp._implementation;
            }
            if (comp.equals) {
                return comp.equals(int);
            }
            return comp === int;
        };
        coll.createTo = function (ext) {
            return ext._implementation;
        };
        coll.createFrom = function (int) {
            var ext = int.externalObject;
            if (!ext) {
                ext = new IgrCellRange();
                if (ext) {
                    ext._implementation = int;
                }
            }
            return ext;
        };
        return coll;
    };
    return IgrGridSelectedCellRangesCollection;
}(IgCollection));
export { IgrGridSelectedCellRangesCollection };
//# sourceMappingURL=igr-grid-selected-cell-ranges-collection.js.map
